import React, { useEffect, useState } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Typography, Box, Paper,
} from '@mui/material';
import { getApiLogs } from '../utils/api';
import Sidebar from '../components/Sidebar';

interface Log {
  id: number;
  endpoint: string;
  request_data: any;
  response_data: any;
  status_code: number;
  created_at: string;
}

const ApiLogs: React.FC = () => {
  const [logs, setLogs] = useState<Log[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getApiLogs();
      setLogs(response.data.data);
    } catch (err) {
      console.error('Failed to fetch API logs', err);
      setError('Failed to load API logs. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Typography>Loading API logs...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar role="superadmin" />
      <Box sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Typography variant="h4" gutterBottom>
          API Logs
        </Typography>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Endpoint</TableCell>
                <TableCell>Request Data</TableCell>
                <TableCell>Response Data</TableCell>
                <TableCell>Status Code</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{log.id}</TableCell>
                  <TableCell>{log.endpoint}</TableCell>
                  <TableCell>
                    <pre>{JSON.stringify(log.request_data, null, 2)}</pre>
                  </TableCell>
                  <TableCell>
                    <pre>{JSON.stringify(log.response_data, null, 2)}</pre>
                  </TableCell>
                  <TableCell>{log.status_code}</TableCell>
                  <TableCell>{new Date(log.created_at).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    </Box>
  );
};

export default ApiLogs;